import React from "react";
import { Router } from "@abyss/web/ui/Router";
import { AppBody } from "../common/AppBody";
import { Home } from "./Home";
import { Proto } from "./Proto";
import { HelloAbyss } from "./HelloAbyss";
import { PlanDetail } from "./PlanDetail";
import { MSPlanDetail } from "./MSPlanDetail";
import { PlanDrawer } from "./PlanDrawer";
import { FloatingChat } from "./FloatingChat";
import { FloatingChatA } from "./FloatingChat/FloatingChatA";
import { FloatingChatB } from "./FloatingChat/FloatingChatB";
import { FloatingChatCompare } from "./FloatingChat/FloatingChatCompare";
import { FloatingChatCompareB } from "./FloatingChat/FloatingChatCompareB";
import { FloatingChatSummary } from "./FloatingChat/FloatingChatSummary";
import { FloatingChatSummaryB } from "./FloatingChat/FloatingChatSummaryB";

export const Routes = () => {
  return (
    <Router.Routes title="{{title}}">
      <Router.Route path="/" element={<AppBody />}>
        <Router.Route path="/" element={<Home />} />
        <Router.Route path="/proto" element={<Proto />} />
        <Router.Route path="/hello-abyss" element={<HelloAbyss />} />
        <Router.Route path="/plan-detail" element={<PlanDetail />} />
        <Router.Route path="/ms-plan-detail" element={<MSPlanDetail />} />
        <Router.Route path="/plan-drawer" element={<PlanDrawer />} />
        <Router.Route path="/floating-chat" element={<FloatingChat />} />
        <Router.Route path="/floating-chat-a" element={<FloatingChatA />} />
        <Router.Route path="/floating-chat-b" element={<FloatingChatB />} />
        <Router.Route
          path="/floating-chat-plan-compare"
          element={<FloatingChatCompare />}
        />
        <Router.Route
          path="/floating-chat-plan-compare-b"
          element={<FloatingChatCompareB />}
        />
        <Router.Route
          path="/floating-chat-plan-summary"
          element={<FloatingChatSummary />}
        />
        <Router.Route
          path="/floating-chat-plan-summary-b"
          element={<FloatingChatSummaryB />}
        />
      </Router.Route>
    </Router.Routes>
  );
};
